import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "hot-sales-content wow animate__fadeInUpBig" }
const _hoisted_2 = { class: "top-text" }
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "bottom" }
const _hoisted_6 = { class: "tips" }
const _hoisted_7 = { class: "swiper" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["src"]

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { GetHotProductResponse } from '@/typeDefine/HttpResponseType'
import { onMounted, ref, Ref } from 'vue'
import { Action } from '@/typeDefine/CommonTypes'
import { UtilMethods } from '@/util/UtilMethods'
import { ResponseCode } from '@/http/ResponseCode'
import { router } from '@/router'
import { Api } from '@/http/Api'
import { ConstantField } from '@/constant/ConstantField'


export default /*@__PURE__*/_defineComponent({
  __name: 'HotSales',
  setup(__props) {


const hotProduct: Ref<GetHotProductResponse['data']['hotProduct']> = ref([])

onMounted(() => {
    requestHotProduct()
})

const requestHotProduct: Action = async () => {
    const response: GetHotProductResponse = await Api.instance.getHotProductList()

    UtilMethods.showMessageToast(response,false)

    if(response.code === ResponseCode.OK) {
        hotProduct.value = response.data.hotProduct
    }
}

const gotoDetails: Action<[number]> = (id: number) => {
    router.push({
        name: 'productDetails',
        params: {
            id,
        }
    })
}

const goProductPage: Action = () => {
    router.push({
        name: 'products'
    })
}

const breakpoints: {
    readonly [K in number]: { readonly slidesPerView: number }
} = {
    // 小屏手机
    0: {
        slidesPerView: 1
    },
    // 中等屏幕（如平板）
    640: {
        slidesPerView: 2
    },
    // 大屏（如一般 PC）
    1024: {
        slidesPerView: 4
    },
    // 超大屏（如 2K 显示器）
    1440: {
        slidesPerView: 5
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('index.hotSales.title')), 1),
        _createElementVNode("div", {
          class: "look-more-product pointer-cursor",
          onClick: goProductPage
        }, _toDisplayString(_ctx.$t('index.hotSales.lookMoreButtonText')), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('index.hotSales.tips')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_unref(Swiper), {
        "slides-per-view": 5,
        "space-between": 20,
        loop: true,
        autoplay: { delay: 3000 },
        modules: [_unref(Autoplay), _unref(Navigation)],
        navigation: "",
        pagination: "",
        breakpoints: breakpoints,
        class: "mySwiper"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hotProduct.value, (item) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: "swiper-item pointer-cursor",
                  onClick: ($event: any) => (gotoDetails(item.id))
                }, [
                  _createElementVNode("img", {
                    src: `${item.cover}`,
                    class: "slide-img"
                  }, null, 8, _hoisted_9),
                  _createElementVNode("p", null, _toDisplayString(item.name), 1)
                ], 8, _hoisted_8)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules"])
    ])
  ]))
}
}

})